import { Controller } from "@hotwired/stimulus";
import { showModal } from "../../src/custom/Modal";

export default class extends Controller {
  showFilter = () => {
    showModal('.filters.modal');
  }
}
